
































































































































import Vue from "vue";
import productCard from "./productCard.vue";
import { FilterInterface } from "@/models/FilterInterface";
import { TProduct } from "@/models/Product";
import { capitalize } from "@/plugins/constants";
import { mapMutations, mapGetters, mapState } from "vuex";
import {
  FilterState,
  FilterMutations,
  TFilterState,
} from "@/store/modules/filter/definitions.filter";
import {
  ProductGetters,
  ProductState,
} from "@/store/modules/product/definitions.product";

import { GET_IMAGE_URL } from "@/plugins/constants";


export default Vue.extend({
  name: "cardsService",
  components: { productCard },
  props: {
    filter: Boolean,
    pagination: Boolean,
    searchText: String,
    limitProducts: Number,
    collection: {
      type: String,
      default: "",
    },
    complements: {
      type: Array,
      default() {
        return [] as Array<TProduct>;
      },
    },
  },
  data: () => ({
    loaded: false,
    selectedModels: [],
    availableModels: [],
    selectedCloths: [],
    availableCloths: [],
    selectedCollection: "Todas",
    availableCollections: [],
    selectedOrderBy: "Novedad",
    availableOrderBy: ["Novedad", "De menor a mayor", "De mayor a menor"],
    cards: [] as Record<string, any>,
    filterIsActive: false,
    filterElements: [[{}]],
    paginationObject: {
      page: 1,
      perPage: 8,
    },
    category: "",
    icons: [
      `${GET_IMAGE_URL(false)}/icons/chevron-up.svg`
    ]
  }),  
  mounted() {
    this.setUp();

    /*const w: Function = this.$watch(ProductState.PRODUCTS_LIST,() => {
      this.setUp();
      w();
    })*/
  },
  methods: {
    ...mapMutations("filter", [
      FilterMutations.SET_FILTER_STATE,
      FilterMutations.SET_CURRENT_PAGE,
    ]),
    removeDuplicate(arr: Array<string>) {
      return arr.filter((elem, pos, array) => {
        return array.indexOf(elem) == pos;
      });
    },
    scrollToTop() {
      // (this.$refs.container as HTMLElement).scrollIntoView({
      //   behavior: "smooth",
      // });
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    next() {
      //Delay to scroll after the component redering
      setTimeout(() => {
        this.scrollToTop();
      }, 100);

      this[FilterMutations.SET_CURRENT_PAGE](this.paginationObject.page);

      this.cards = this.filterElements[this.paginationObject.page - 1];
    },
    createFilterObject(config: FilterInterface): FilterInterface {
      const newFilterObject = {} as FilterInterface;
      let k: keyof FilterInterface;

      for (k in config) {
        const val = config[k];

        const ele = val || undefined;

        if (ele !== undefined && ele.length) {
          newFilterObject[k] = ele;
        }
      }

      return newFilterObject;
    },
    setFilter() {      
      this[FilterMutations.SET_FILTER_STATE]({
        selectedModels: this.selectedModels,
        selectedCloths: this.selectedCloths,
        selectedCollection: this.selectedCollection,
        selectedOrderBy: this.selectedOrderBy,
        currentPage: this.paginationObject.page,
      } as TFilterState);

      const objAux: FilterInterface = {
        cloths: this.selectedCloths,
        model: this.selectedModels,
      };

      this.selectedCollection != "Todas" &&
        (objAux.collections = [capitalize(this.selectedCollection)]);

      const filter = this.createFilterObject(objAux);

      this.filterElements = this[ProductGetters.GET_CONDITIONAL_PRODUCTS](
        filter,
        this.paginationObject.perPage,
        false,
        false,
        this.selectedOrderBy
      );

      if (this.filterElements.length) {
        // this.filterIsActive = true;

        this.paginationObject.page = 1;

        this.cards = this.filterElements[0];
      } else {
        // this.filterIsActive = false;
        this.paginationObject.page = 1;
        this.filterElements = [];
        this.cards = [];
      }
    },
    search() {
      this.filterIsActive = true;
      const wordsToSearch = this.searchText.split(" ");
      const aux = this[ProductGetters.GET_CONDITIONAL_PRODUCTS](
        {},
        this.paginationObject.perPage,
        false,
        false
      );
      const prods = aux.flat();
      let filterArr: any = [];

      //iterate different word input
      for (let index = 0; index < wordsToSearch.length; index++) {
        const word = wordsToSearch[index].toUpperCase();
        const filterCards = prods.filter((ele: TProduct) => {
          // let k: keyof typeof ele;
          //          String  String        String  Array<string>  Obj    Obj
          const k = [
            "title",
            "description",
            "model",
            "collections",
            "cloths",
            "sizes",
            "colors",
          ];
          //iterate object to find word
          for (let i = 0; i < k.length; i++) {
            if (Object.prototype.hasOwnProperty.call(ele, k[i])) {
              const element = ele[k[i]];
              if (JSON.stringify(element).toUpperCase().indexOf(word) != -1) return ele;
            }
          }
        });

        filterArr = filterArr.concat(filterCards);
      }
      //Delete duplicate article
      filterArr = filterArr.filter(
        (thing: TProduct, index: number, self: Array<TProduct>) =>
          index === self.findIndex((t) => t._id === thing._id)
      );
      //Make a paginator
      this.filterElements = filterArr.reduce(
        (rows: any, key: number, index: number) =>
          (index % this.paginationObject.perPage == 0
            ? rows.push([key])
            : rows[rows.length - 1].push(key)) && rows,
        []
      );

      this.cards = this.filterElements[0];
    },
    setUp() {
      if (this.complements.length > 0) {
        this.cards = JSON.parse(JSON.stringify(this.complements));
      } else {
        //If filter and pagination are false, you're on Home Page or on description product
        if (!this.filter && !this.pagination) {
          this.cards = this[ProductGetters.GET_CONDITIONAL_PRODUCTS](
            { collections: this.collection },
            this.limitProducts,
            true
          );
        } else {
          //If filter is true, you are GridCard page
          if (this.filter) {
            const {
              universe,
              availableCloths,
              availableModels,
              availableCollections,
            } = this[ProductGetters.GET_CONDITIONAL_PRODUCTS](
              {},
              this.paginationObject.perPage
            );

            this.filterElements = universe;

            this.availableCloths = availableCloths;
            this.availableModels = availableModels;
            this.availableCollections = availableCollections;

            //Set statuses with saved values
            this.selectedModels = this.filter_models;
            this.selectedCloths = this.filter_cloths;
            this.selectedCollection = this.filter_collection;
            this.selectedOrderBy = this.filter_order_by;
            this.paginationObject.page = this.filter_current_page;

            //When restore filter elements are empty, you have to initialize the original card with correct page
            if (
              !this.selectedModels.length &&
              !this.selectedCloths.length &&
              !this.selectedCollection.length
            ) {
              this.cards = this.filterElements[this.paginationObject.page - 1];
            } //If Items aren't empty, you have to apply Filter
            else {
              this.setFilter();
              this.paginationObject.page = this.filter_current_page;
              this.next();
            }
          } else {
            //Here is the Search Section
            this.search();
          }
        }
      }

      // console.dir(this.availableCloths);
      // console.dir(this.availableModels);

      this.loaded = true;
    },
  },
  computed: {
    ...mapGetters("product", [ProductGetters.GET_CONDITIONAL_PRODUCTS]),
    ...mapState("filter", {
      filter_models: FilterState.SELECTED_MODELS,
      filter_cloths: FilterState.SELECTED_CLOTHS,
      filter_collection: FilterState.SELECTED_COLLECTION,
      filter_order_by: FilterState.SELECTED_ORDER_BY,
      filter_current_page: FilterState.CURRENT_PAGE,
    }),
    ...mapState("product", [ProductState.PRODUCTS_LIST]),
  },
  watch: {
    [ProductState.PRODUCTS_LIST]() {
      this.setUp();
    },
  },
});
